<template>
    <div class="container">
       <div class="row justify-content-center">
           <div class="col-8">
               <form @submit.prevent="onUpdateForm">
                   <h3 class="text-center mt-5 mb-5">Редактиране на {{ user.name }}</h3>
                   <div class="form-group">
                       <label>Снимка</label>
                       <img class="d-block img" :src="user.image" alt="">
                   </div>
                   <div class="form-group">
                       <label>Име</label>
                       <input type="text" class="form-control" v-model="user.name" required>
                   </div>
                   <div class="form-group">
                       <label>Биография</label>
                       <div class="editor-wrapper">
                           <vue-editor v-model="user.story" required></vue-editor>
                       </div>
                   </div>

                   <div class="form-group">
                       <button class="btn btn-primary btn-block">Запази</button>
                   </div>
               </form>
           </div>
       </div>
    </div>
</template>

<script>
    import { db } from '../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                user: {
                }
            }
        },
        created() {
            let dbRef = db.collection('team').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.user = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        },
        methods: {
            onUpdateForm(event) {
                event.preventDefault();
                db.collection('team').doc(this.$route.params.id)
                    .update(this.user).then(() => {
                    console.log("User successfully updated!");
                    this.$router.push('/list')
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>
